module.exports = __webpack_public_path__ + "img/LV1.202de74b.png";